import React from 'react';
import FileUploader from '../shared/FileUploader';
import TrackList from '../shared/TrackList';
import ActionButtons from '../shared/ActionButtons';

const TrackInfoTab = ({
  uploadText,
  readFile,
  uploadProgress,
  tracks,
  onDragEnd,
  onEditTrack,
  onRemoveTrack,
  handleSave,
  isSaving,
  setTab
}) => {
  return (
    <div className="row">
      <div className="col-md-6 mt-3">
        <FileUploader
          label="Add Track"
          text={uploadText}
          onChange={readFile}
          multiple={true}
          progress={uploadProgress}
        />
      </div>
      <div className="col-md-6 mt-3">
        <TrackList
          tracks={tracks}
          onDragEnd={onDragEnd}
          onEditTrack={onEditTrack}
          onRemoveTrack={onRemoveTrack}
        />
      </div>
      <div className="col-12 mt-4">
        <ActionButtons
          onSave={handleSave}
          onNext={() => setTab(4)}
          isSaving={isSaving}
        />
      </div>
    </div>
  );
};

export default TrackInfoTab; 